import { useData } from 'context/DataContext'
import React, { useEffect, useState } from 'react'

const platforms = ['Fiverr', 'Upwork', 'Others']

const Platform = () => {
  const [filterProjectData, setFilterProjectData] = useState([])
  const [filterState, setFilterState] = useState([])
  const [portfolioCheck, setPortfolioCheck] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const { data } = useData()

  const handleChangeFilter = (e) => {
    if (e.target.checked) {
      setFilterState([...filterState, e.target.value])
    } else {
      let filter = filterState.filter((val) => val !== e.target.value)
      setFilterState(filter)
    }
  }

  const handleRadio = (e) => {
    // console.log(e.target.value);
    setPortfolioCheck(e.target.value)
  }
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
  }

  useEffect(() => {
    setFilterProjectData(data)
  }, [data])

  useEffect(() => {
    let filterData = data.filter((val) => {
      // if categroy filter selected
      if (filterState.length > 0 && portfolioCheck.length > 0) {
        return filterState.some((el) => {
          return (
            val.inputValues.platform.toLowerCase() === el.toLowerCase() &&
            val.inputValues.portfolio === portfolioCheck &&
            val.inputValues.name
              .toLowerCase()
              .includes(searchValue.toLowerCase())
          )
        })
      } else if (filterState.length === 0 && portfolioCheck.length > 0) {
        return (
          val.inputValues.portfolio === portfolioCheck &&
          val.inputValues.name.toLowerCase().includes(searchValue.toLowerCase())
        )
      } else if (filterState.length > 0 && portfolioCheck.length === 0) {
        return filterState.some((el) => {
          return (
            val.inputValues.platform.toLowerCase() === el.toLowerCase() &&
            val.inputValues.name
              .toLowerCase()
              .includes(searchValue.toLowerCase())
          )
        })
      } else {
        return val.inputValues.name
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      }
    })
    // console.log(filterState);
    if (
      filterState.length > 0 ||
      portfolioCheck !== '' ||
      searchValue !== ''
      //   ||
      //   filterState.length > 0 ||
      //   portfolioCheck === ""
    ) {
      setFilterProjectData(filterData)
    } else {
      setFilterProjectData(data)
    }
  }, [filterState, portfolioCheck, searchValue])

  return (
    <div>
      <div>
        <br />
        <div style={{ width: '30%' }} className="fList">
          <h2> Filters </h2>
          <p>Platform :</p>
          <ul className="">
            {platforms.length > 0
              ? platforms.map((val) => (
                  <li
                    className="cs_row px-2 py-1  justify-content-between align-items-center"
                    key={val}
                  >
                    <span>{val}</span>
                    <input
                      type="checkbox"
                      value={val}
                      onChange={handleChangeFilter}
                    />
                  </li>
                ))
              : null}
          </ul>
          <p>Portfolio :</p>
          <div>
            <label
              htmlFor="true"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>True</p>
              <input
                type="radio"
                name="portfolio"
                id="true"
                value="true"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="false"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>False</p>
              <input
                type="radio"
                name="portfolio"
                id="false"
                value="false"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="all"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>All</p>
              <input
                type="radio"
                name="portfolio"
                id="all"
                value=""
                onChange={handleRadio}
              />
            </label>
          </div>
        </div>
        <br />
        <div className="searchBar">
          <div style={{ width: '50%' }}>
            <input
              type="text"
              value={searchValue}
              placeholder="Search with project name"
              onChange={handleSearch}
            />
          </div>
          <br />
        </div>

        <div>
          <p className="numProj">
            Number Of Projects : {filterProjectData.length}
          </p>
        </div>
        <br />
        <div className="tbSection">
          <table id="customers">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Link</th>
                <th>Name</th>
                <th>Category</th>
                <th>Description</th>
                <th>Platform</th>
                <th>Beckend</th>
                <th>Portfolio</th>
                <th>Status</th>
                <th>Order No</th>
              </tr>
            </thead>
            <tbody>
              {filterProjectData.length > 0
                ? filterProjectData.map((val, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td id="links">
                        <a
                          href={val.inputValues.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {val.inputValues.link}
                        </a>{' '}
                      </td>
                      <td>{val.inputValues.name}</td>
                      <td>
                        {val.categories.map((res) => (
                          <span key={res}>{' ' + res + ' '}</span>
                        ))}
                      </td>
                      <td style={{ minWidth: '200px' }}>
                        {val.inputValues?.description}
                      </td>
                      <td>
                        {val.inputValues.platform
                          ? val.inputValues.platform
                          : null}
                      </td>
                      <td>{val.inputValues.beckend}</td>
                      <td>{val.inputValues.portfolio}</td>
                      <td>{val.inputValues?.status}</td>
                      <td>{val.inputValues.order_number}</td>
                      {/* <td className="cs_row">
                        <button onClick={() => handleDelete(val.id)}>
                          &#10060;
                        </button>{" "}
                        <button onClick={() => handleEdit(val)}>&#9998;</button>
                      </td> */}
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Platform
